import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const points = ['Sin saber cuánto cobrar y terminando la semana con menos plata de la que tenías.', 'Improvisando el packaging a último momento porque te olvidaste de comprar algo.', 'Perdiendo ventas por WhatsApp porque tardás horas en responder o mandás solo el precio.', 'Sin fotos profesionales, haciendo que tu desayuno de calidad parezca un combo barato.', 'Mezclando la plata de la casa con la del negocio, sin saber nunca si estás ganando o perdiendo.', 'Llegando al domingo agotado/a y sin haber generado el ingreso que esperabas.'];
  return <section className="py-20 px-4 bg-dark-card/30 border-y border-dark-border pt-[15px] pb-[15px]" data-id="element-201">
      <div className="max-w-3xl mx-auto space-y-[16px]" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-203">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-204">
            ¿Cuántos domingos más vas a estar así?
          </h2>
          <p className="text-base text-gray-400" data-id="element-205">
            Querés emprender, pero nadie te dijo que ibas a pasar las noches
            buscando qué productos poner, sufriendo cada vez que vas al súper
            porque "todo subió" y rogando que alguien te pregunte el precio en
            Instagram.
          </p>
          <p className="text-xl font-bold text-brand mt-[24px] mb-[-30px]" data-id="element-206">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-207">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start space-x-4 bg-dark-card border border-dark-border p-4 rounded-xl" data-id="element-208">
              <div className="mt-1 bg-red-500/20 p-1 rounded-full" data-id="element-209">
                <X className="w-5 h-5 text-red-500" data-id="element-210" />
              </div>
              <p className="text-gray-300 text-lg" data-id="element-211">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-212">
          <h3 className="text-2xl md:text-4xl font-black text-white mt-[-30px]" data-id="element-213">
            ¿Y si este fuera el último finde que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}